import script from "./ChartSimulator.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartSimulator.vue?vue&type=script&setup=true&lang=js"

import "./ChartSimulator.vue?vue&type=style&index=0&id=bceb9db2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bceb9db2"]])

export default __exports__